import React from 'react'
import Helmet from 'react-helmet-async'
import { Query } from 'react-apollo'

import { GET_SONGS } from '../graphql/queries'

import GetUser from '../hocs/queries/GetUser'

// Our Base Components
import Breadcrumb from '../components/Breadcrumb'
import Hero from '../components/Hero'
import SectionContainer from '../components/SectionContainer'
import SongTileList from '../components/SongTileList'

class AllSongsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchTerm: ''
    }
  }
   getSearchTerm=(value)=>{
     this.setState({
       searchTerm: value
     })
   }

   render() {
     const { searchTerm } = this.state
     return (
      <>
        <Helmet>
          <title>Songs</title>
        </Helmet>
        <main className='main'>
          <Hero src='ph.hero.projects.jpg'
            alt='Alt text'
            subtitle='Songs'
            showSearch={true}
            getSearchTerm={this.getSearchTerm}
            btnOnClick ={()=>{
              this.props.history.push('/songs/create')
            }}
            btnText= 'Add'
          >
            <Breadcrumb items={[
              {
                href: `/files`,
                name: 'Files'
              },
              {
                href: `/files/songs`,
                name: 'Songs'
              }
            ]} />
          </Hero>

          <div className='mainContainer'>
            <div className='songs-tiles project-files'>
              <SectionContainer>
                <Query query={GET_SONGS}
                  variables={{
                    userId: this.props.user.id
                  }}
                  fetchPolicy='network-only'>
                  {({ loading, error, data, refetch }) => {
                    if (error) {
                      return `Error! ${error.message}`
                    }
                    const filteredRows = data.getSongs && data.getSongs.filter(({ title })=> title.toLowerCase().includes(searchTerm.toLowerCase()))
                    return (
                      <SongTileList songs={searchTerm ? filteredRows : data.getSongs || []}
                        showLoader={loading}
                        withOptions
                        refetch={refetch}
                        user={this.props.user} />
                    )
                  }}
                </Query>
              </SectionContainer>
            </div>
          </div>
        </main>
      </>
     )
   }
}

export default GetUser(AllSongsPage)
